import { render } from "./MilestoneGroup.vue?vue&type=template&id=a06e9652"
import script from "./MilestoneGroup.vue?vue&type=script&lang=js"
export * from "./MilestoneGroup.vue?vue&type=script&lang=js"

import "./MilestoneGroup.vue?vue&type=style&index=0&id=a06e9652&lang=css"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__